// extracted by mini-css-extract-plugin
export default {"dots":"foldable-text_dots__iAc+6"};